import React from 'react';
import { useZitoneoServices } from '../../../contexts/ZitoneoContentContext';
import { ZitoneoPreviewMode } from '../../../types/zitoneoServicesTypes';
import ModeSelector from './ModeSelector';

const PreviewModeSelector = () => {
    const { changePreviewMode, previewMode } = useZitoneoServices();

    return (
        <ModeSelector
            selectedValue={previewMode}
            onChange={changePreviewMode}
            options={[
                {
                    value: ZitoneoPreviewMode.DESKTOP,
                    iconName: 'Laptop',
                },
                {
                    value: ZitoneoPreviewMode.TABLET,
                    iconName: 'Tablet',
                },
                {
                    value: ZitoneoPreviewMode.MOBILE,
                    iconName: 'Smartphone',
                },
            ]}
        />
    );
};

export default PreviewModeSelector;
